import { LazyLoader } from '@bp/ui-components';
import classNames from 'classnames';
import { Suspense, useContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styles from './App.module.css';
import { AppHeader } from './components/AppHeader/AppHeader';
import { Breadcrumb } from './components/Breadcrumb/Breadcrumb';
import { Sidebar } from './components/Sidebar/Sidebar';
import { AppLayoutContext } from './contexts/AppLayoutContextProvider';

export const DataLoader = () => {
  const mainClasses = classNames(styles.content, 'has-scrollbar');
  const { scrollRef } = useContext(AppLayoutContext);
  const navigate = useNavigate();

  return (
    <div className={styles.app}>
      <div className={styles['sidebar-slot']}>
        <Sidebar />
      </div>
      <AppHeader />
      <div className={mainClasses} id='content' data-cy='layoutContentColumn' ref={scrollRef}>
        <main className={styles.container}>
          <Breadcrumb onNavigate={(path) => navigate(path)} />
          <Suspense fallback={<LazyLoader transparent forceHeight='50vh' fullWidth size='xxl' />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
};
